// extracted by mini-css-extract-plugin
export var locationCard = "_eu-0";